import React from "react";
import { View, StyleSheet } from "react-native";
import { useTheme } from "@/hooks/useTheme";
import { PositionStats } from "./types";

type PositionStatusBarProps = {
  stats: PositionStats;
};

export function PositionStatusBar({ stats }: PositionStatusBarProps) {
  const { colors } = useTheme();

  const { total, queued, invited, accepted, empty } = stats;

  if (total === 0) return null;

  const queuedPercent = (queued / total) * 100;
  const invitedPercent = (invited / total) * 100;
  const acceptedPercent = (accepted / total) * 100;
  const emptyPercent = (empty / total) * 100;

  return (
    <View style={[styles.statusBar, { backgroundColor: colors.background, borderColor: colors.border }]}>
      {accepted > 0 && (
        <View style={[styles.segment, { width: `${acceptedPercent}%`, backgroundColor: colors.emerald.border }]} />
      )}
      {invited > 0 && (
        <View style={[styles.segment, { width: `${invitedPercent}%`, backgroundColor: colors.indigo.border }]} />
      )}
      {queued > 0 && (
        <View style={[styles.segment, { width: `${queuedPercent}%`, backgroundColor: colors.amber.border }]} />
      )}
      {empty > 0 && (
        <View
          style={[
            styles.segment,
            { width: `${emptyPercent}%`, backgroundColor: colors.backgroundSecondary, opacity: 0.5 },
          ]}
        />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  statusBar: {
    height: 4,
    borderRadius: 2,
    overflow: "hidden",
    borderWidth: StyleSheet.hairlineWidth,
    flexDirection: "row",
  },
  segment: {
    height: "100%",
  },
});
